import React from 'react'
import * as UI from 'ui'
import * as Displays from 'support/displays'
import { ForEachModel } from '@morningtrain/react-resources'
import AvatarWrapper from 'ui/partials/AvatarWrapper'

export default function EmployeesCalendarColumnInner () {
  return (
    <>
      <div className='employee cell bg-gray-700'>
        <UI.Text weight='medium' color='white'>
          <Displays.Enum name='key' enum='employment_type_category' />
        </UI.Text>
      </div>
      <ForEachModel>
        <div
          className='employee cell user-column flex items-center flex-shrink-0 border-t border-gray-200 py-7 pl-2'
        >
          <div className='avatar-circle'>
            <AvatarWrapper classes='' margin='mr-2'>
              <Displays.Image name='user.avatar_url' />
            </AvatarWrapper>
          </div>
          <div className='user-meta-column'>
            <div className='font-medium text-sm truncate w-40'>
              <Displays.Text name='user.name' />
            </div>
          </div>
        </div>
      </ForEachModel>
    </>
  )
}
